const SignUpSuccess = () => {
  return (<>
    <h1>Thank you, we have received your request.</h1>
    <p>You will receive an email once your Retailer ID has been generated.</p>
  </>)
}

export default SignUpSuccess;
